import styled, { css } from "styled-components";
import { getColor, getSize, responsive } from "~/spocketUI/helpers/style";
import { UIProps } from "~/spocketUI/types/style";

interface IPlanCard extends UIProps {
  primary: boolean;
}

export const PlanCardContainer = styled.div<IPlanCard>`
  padding: ${getSize(3.7)} ${getSize(1.5)};
  align-items: baseline;
  position: relative;
  max-width: 260px;
  min-width: 170px;
  min-height: 446px;
  height: auto;
  border: 1px solid ${getColor("disabled")};
  border-radius: 11px;

  ${({ primary }) =>
    primary &&
    css`
      background-color: ${getColor("primary")}22;
      border: 2px solid ${getColor("primary")};
    `}
`;

export const PlanCardPromotion = styled.div<{ isHighlighted: boolean }>`
  position: absolute;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  left: 0;
  border-radius: 9px 9px 0 0;
  padding: 2px 0;
  font-weight: 500;
  background-color: ${getColor("greenSecondary")};
  color: ${getColor("green")};

  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      background-color: ${getColor("primary")};
      color: ${getColor("white")};
    `}
`;

export const ButtonContainer = styled.div`
  text-align: center;
  padding-top: ${getSize(2)};
`;

export const PlanCardTitle = styled.h2`
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  position: relative;
`;

export const PlanCardSubtitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 ${getSize(1.6)} 0;
  position: relative;
  color: ${getColor("textSecondary")};
`;

export const PlanCardPrice = styled.h3`
  font-size: 28px;
  font-weight: 700;
  position: relative;
  display: flex;
  align-items: center;
  gap: ${getSize(0.5)};
`;

export const MostPopularText = styled.span`
  color: ${getColor("white")};
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const DiscountText = styled.span`
  width: max-content;
  color: ${getColor("textSecondary")};
  opacity: 0.5;
  text-decoration: line-through;
  margin-right: ${getSize(0.6)};
`;

export const MonthlyValue = styled.span`
  color: ${getColor("textSecondary")};
  font-size: 12px;
  font-weight: 500;
`;

export const PlanCardList = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  font-size: 16px;
  gap: ${getSize(1)};
  margin-top: ${getSize(2)};
`;

export const PlanCardItem = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${getSize(1.2)};
`;

export const FeatureText = styled.div`
  width: calc(100% - ${getSize(3.6)});
`;
